import { SortDirection as TableSortDirection } from "@songtradr-one/components-frontend";
import { SortDirection } from "@songtradr-one/shared-common";

const directions: Record<TableSortDirection, SortDirection> = {
  [TableSortDirection.ASCENDING]: SortDirection.Ascending,
  [TableSortDirection.DESCENDING]: SortDirection.Descending,
  [TableSortDirection.NONE]: SortDirection.None,
};

/**
 * Turns a table's sort state into a schema sort input.
 *
 * The design language ships standalone, so it carries its own SortDirection
 * rather than the generated one. The two hold identical strings but TS enums
 * are nominal, so the directions are mapped member to member - if either enum
 * grows a member the mapping stops compiling.
 *
 * The key is a column name, which the schema only accepts if it is one of its
 * sort keys - so the guard is applied here rather than asserted, and a column
 * the API can't sort by is dropped instead of being sent.
 */
export const toSchemaSort = <TKey extends string>(
  { key, direction }: { key?: PropertyKey; direction: TableSortDirection },
  isValidKey: (value: string) => value is TKey,
): { key?: TKey; direction: SortDirection } => ({
  key: typeof key === "string" && isValidKey(key) ? key : undefined,
  direction: directions[direction],
});
